import { createSelector, createFeatureSelector } from '@ngrx/store';
import { UserState } from '@models/index';

export const userSelector = createFeatureSelector<UserState>('user');
export const getUserSelector = createSelector(userSelector, (state: UserState) => state);
export const getnextResend = createSelector(userSelector, (state: UserState) => new Date(state.user.code_sent_at).getTime() + 3 * 60 * 1000);
export const getProfileSelector = createSelector(userSelector, (state: UserState) => state.user);
export const getFiltersSelector = createSelector(userSelector, (state: UserState) => state.filters);
export const getSelectedFilterSelector = createSelector(userSelector, (state: UserState) => state.filters.selectedItem);
export const getAuthToken = createSelector(userSelector, (state: UserState) => state.authToken);
export const isUserAuthenticated =  createSelector(userSelector, (state: UserState) => !!state.authToken);
export const getUserLoginHistory = createSelector(userSelector, (state: UserState) => state.loginHistories);
